import RBush from "rbush";
class TldrawRBush extends RBush {
}
class RBushIndex {
  rBush;
  elementsInTree;
  constructor() {
    this.rBush = new TldrawRBush();
    this.elementsInTree = /* @__PURE__ */ new Map();
  }
  /**
   * Search for shapes within the given bounds.
   * Returns set of shape IDs that intersect with the bounds.
   */
  search(bounds) {
    const results = this.rBush.search({
      minX: bounds.minX,
      minY: bounds.minY,
      maxX: bounds.maxX,
      maxY: bounds.maxY
    });
    return new Set(results.map((e) => e.id));
  }
  /**
   * Remove a shape from the spatial index.
   */
  remove(id) {
    const element = this.elementsInTree.get(id);
    if (element) {
      this.rBush.remove(element);
      this.elementsInTree.delete(id);
    }
  }
  /**
   * Apply the removals and upserts collected during one incremental update.
   * Mutations are applied per item: bulk-rebuilding the whole tree instead
   * was measured slower even with ~10% of the index in the batch.
   */
  applyBatch(removes, upserts) {
    for (const id of removes) {
      this.remove(id);
    }
    for (const element of upserts) {
      const existing = this.elementsInTree.get(element.id);
      if (existing) {
        this.rBush.remove(existing);
      }
      this.rBush.insert(element);
      this.elementsInTree.set(element.id, element);
    }
  }
  /**
   * Bulk load elements into the spatial index.
   * More efficient than individual inserts for initial loading.
   */
  bulkLoad(elements) {
    this.rBush.load(elements);
    for (const element of elements) {
      this.elementsInTree.set(element.id, element);
    }
  }
  /**
   * Clear all elements from the spatial index.
   */
  clear() {
    this.rBush.clear();
    this.elementsInTree.clear();
  }
  /**
   * Check if a shape is in the spatial index.
   */
  has(id) {
    return this.elementsInTree.has(id);
  }
  /**
   * Get the number of elements in the spatial index.
   */
  getSize() {
    return this.elementsInTree.size;
  }
  /**
   * Get the raw stored element for a shape, without allocating a Box.
   * Use when you only need to read the indexed bounds for comparison.
   *
   * @internal
   */
  getElement(id) {
    return this.elementsInTree.get(id);
  }
  /**
   * Dispose of the spatial index.
   * Clears all data structures to prevent memory leaks.
   */
  dispose() {
    this.clear();
  }
}
export {
  RBushIndex
};
//# sourceMappingURL=RBushIndex.mjs.map
